<template>
  <div class="rounded-full bg-primary-50 text-sm px-2 inline-block">
    <slot />
  </div>
</template>
